import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyCropReconcilliation2Listing } from './Pages'

export const DailyCropReconcilliation2Routes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyCropReconcilliation2Listing} />
    </Fragment>
)